export default __webpack_public_path__ + "static/media/btc.99166455.svg";